import { Spinner } from '@blueprintjs/core';
import * as React from 'react';
import { Route, Router, Switch, Redirect } from 'react-router';

import Login from 'vms/features/accounts/Login';
import {
  requireAuthenticated,
  requireUnauthenticated,
} from 'vms/features/accounts/utils';
import { redirectIfInWork } from 'vms/features/accounts/wrappers';

import { history } from './configureApp';
import Base from './layout/Base';
import NotFound from './layout/NotFound';

const VehicleRouter = React.lazy(() => import('vms/features/vehicles/router'));

const PartRouter = React.lazy(() => import('vms/features/parts/router'));

const VendorSubletListView = React.lazy(
  () => import('vms/features/sublet/VendorSubletListView')
);

const SettingsRouter = React.lazy(() => import('vms/features/settings/router'));

const ChartRouter = React.lazy(() => import('vms/features/charts/router'));

// In-work redirects need the current user, which Base loads, so they live inside it.
const InWorkRoutes = redirectIfInWork(() => (
  <Switch>
    <Route
      path="/"
      exact
      strict
      render={() => <Redirect push={false} to="/vehicles/?ordering=in_status_age" />}
    />
    <Route exact={false} path="/vehicles" component={VehicleRouter} />
    <Route exact={false} path="/parts" component={PartRouter} />
    <Route exact path="/vendor-sublets/" component={VendorSubletListView} />
    <Route exact={false} path="/settings" component={SettingsRouter} />
    <Route exact={false} path="/charts" component={ChartRouter} />
    <Route component={NotFound} />
  </Switch>
));

const AuthRoutes = () => (
  <Base>
    <InWorkRoutes />
  </Base>
);

const AppRouter = () => (
  <React.Suspense fallback={<Spinner />}>
    <Router history={history}>
      <Switch>
        {/* redirect to the same url with trailing slash appended */}
        <Route
          path="/:url*"
          exact
          strict
          render={(props) => <Redirect push={false} to={`${props.location.pathname}/`} />}
        />
        <Route exact={true} path="/login/" component={requireUnauthenticated(Login)} />
        <Route exact={false} path="/" component={requireAuthenticated(AuthRoutes)} />
      </Switch>
    </Router>
  </React.Suspense>
);

export default AppRouter;
